import React from 'react'
import {COUNTRY_SELECT_OPTIONS} from 'utils/countrySelect'

type Props = {
  name: string
  value: string
  onChange: React.ChangeEventHandler<HTMLSelectElement>
  onBlur: React.FocusEventHandler<HTMLSelectElement>
  id?: string
}

export function CountrySelect(props: Props) {
  const {name, value, onChange, onBlur, id} = props
  const upper = (value || '').toUpperCase()
  const v = COUNTRY_SELECT_OPTIONS.some((o) => o.code === upper) ? upper : 'BG'

  return (
    <div className="contact__select mb-15">
      <select id={id} name={name} value={v} onChange={onChange} onBlur={onBlur}>
        {COUNTRY_SELECT_OPTIONS.map(({code, name: label}) => (
          <option key={code} value={code}>
            {label} ({code})
          </option>
        ))}
      </select>
    </div>
  )
}
